import styled from 'styled-components'

const LandingPartnersStyle = styled.div`
	--partnersMarginBottom: var(--sp8x);
	--imageSizes: var(--sp32x);
	--imageMarginBottom: var(--sp5x);
	--sliderButtonSizes: var(--sp5x);
	--sliderPrevButtonMarginRight: var(--sp7x);
	--slidePadding: var(--sp5x);
	--roleMargin: var(--sp2x) 0 var(--sp5x) 0;
	--decorativeIconPosition: var(--sp5x);
	--decorativeIconSizes: var(--sp7x);

	.title-and-arrows-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: var(--partnersMarginBottom);

		.arrows-wrap {
			.slider-button {
				display: inline-block;
				font-size: var(--sliderButtonSizes);
				cursor: pointer;

				&.swiper-button-disabled {
					color: var(--secondaryColor4);
					pointer-events: none;
				}

				&.slider-prev-button {
					transform: rotate(180deg);
					margin-right: var(--sliderPrevButtonMarginRight);
				}
			}
		}
	}

	.swiper-slide {
		height: auto;
		padding: var(--slidePadding);
		background-color: var(--primaryColor3);
		border-radius: var(--sp2x);
		position: relative;

		.role {
			margin: var(--roleMargin);
		}

		.slide-image {
			width: var(--imageSizes);
			padding-top: var(--imageSizes);
			margin-bottom: var(--imageMarginBottom);

			img {
				border-radius: var(--sp2x);
			}
		}

		.decorative-icon {
			position: absolute;
			top: var(--decorativeIconPosition);
			right: var(--decorativeIconPosition);
			font-size: var(--decorativeIconSizes);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--partnersMarginBottom: var(--sp7x);
		--imageSizes: var(--sp24x);
		--imageMarginBottom: var(--sp4x);
		--sliderButtonSizes: var(--sp4x);
		--sliderPrevButtonMarginRight: var(--sp5x);
		--slidePadding: var(--sp4x);
		--roleMargin: var(--sp2x) 0 var(--sp4x) 0;
		--decorativeIconPosition: var(--sp4x);
		--decorativeIconSizes: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--partnersMarginBottom: var(--sp6x);
		--imageSizes: var(--sp21x);
		--imageMarginBottom: var(--sp4x);
		--sliderButtonSizes: var(--sp4x);
		--sliderPrevButtonMarginRight: var(--sp5x);
		--slidePadding: var(--sp4x);
		--roleMargin: var(--sp2x) 0 var(--sp4x) 0;
		--decorativeIconPosition: var(--sp4x);
		--decorativeIconSizes: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--partnersMarginBottom: var(--sp6x);
		--imageSizes: var(--sp19x);
		--imageMarginBottom: var(--sp4x);
		--sliderButtonSizes: var(--sp4x);
		--sliderPrevButtonMarginRight: var(--sp5x);
		--slidePadding: var(--sp4x);
		--roleMargin: var(--sp2x) 0 var(--sp4x) 0;
		--decorativeIconPosition: var(--sp4x);
		--decorativeIconSizes: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--partnersMarginBottom: var(--sp5x);
		--imageSizes: var(--sp17x);
		--imageMarginBottom: var(--sp3x);
		--sliderButtonSizes: var(--sp4x);
		--sliderPrevButtonMarginRight: var(--sp4x);
		--slidePadding: var(--sp3x);
		--roleMargin: var(--sp2x) 0 var(--sp3x) 0;
		--decorativeIconPosition: var(--sp3x);
		--decorativeIconSizes: var(--sp4x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--partnersMarginBottom: var(--sp4x);
		--imageSizes: var(--sp15x);
		--imageMarginBottom: var(--sp3x);
		--sliderButtonSizes: var(--sp3x);
		--sliderPrevButtonMarginRight: var(--sp4x);
		--slidePadding: var(--sp3x);
		--roleMargin: var(--sp2x) 0 var(--sp3x) 0;
		--decorativeIconPosition: var(--sp3x);
		--decorativeIconSizes: var(--sp4x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--partnersMarginBottom: var(--sp4x);
		--imageSizes: var(--sp15x);
		--imageMarginBottom: var(--sp3x);
		--sliderButtonSizes: var(--sp3x);
		--sliderPrevButtonMarginRight: var(--sp4x);
		--slidePadding: var(--sp3x);
		--roleMargin: var(--sp2x) 0 var(--sp3x) 0;
		--decorativeIconPosition: var(--sp3x);
		--decorativeIconSizes: var(--sp4x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--partnersMarginBottom: var(--sp4x);
		--imageSizes: var(--sp13x);
		--imageMarginBottom: var(--sp3x);
		--sliderButtonSizes: var(--sp3x);
		--sliderPrevButtonMarginRight: var(--sp4x);
		--slidePadding: var(--sp3x);
		--roleMargin: var(--sp1x) 0 var(--sp3x) 0;
		--decorativeIconPosition: var(--sp3x);
		--decorativeIconSizes: var(--sp4x);
	}
`

export default LandingPartnersStyle
